var pictures = [];

var counters = [
    document.querySelector('#image-counter'),
    document.querySelector('#no-of-pics')
];

var frames = {
    frame_1: document.querySelector('.frame-1'),
    frame_2: document.querySelector('.frame-2'),
    frame_3: document.querySelector('.frame-3'),
    inner_1: document.querySelector('.inner_1'),
    inner_2: document.querySelector('.inner_2'),
    inner_3: document.querySelector('.inner_3')
}

var animList = {
    anim_1: 'hide',
    anim_2: 'slide_into',
    anim_3: 'slide_in',
    anim_4: 'enlarge',
    anim_5: 'ride_along',
    anim_6: 'slide-right',
    anim_7: 'slide-out',
    anim_8: 'disappear',
    anim_9: 'shrink'
};

// initializing the turn indicator that will be used to switch positions and animations between divs

var turn = 0;
var indexPic = 1;
var picCounter = 3;
var picCounterBack;
var firstTime = true;



function initialize(pics) {//{imageCounter, noofpics, frame1, frame2, frame3, inner1, inner2, inner3}, pictures){
    pictures = pics

    counters = [
        document.querySelector('#image-counter'),
        document.querySelector('#no-of-pics')
    ];

    frames = {
        frame_1: document.querySelector('.frame-1'),
        frame_2: document.querySelector('.frame-2'),
        frame_3: document.querySelector('.frame-3'),
        inner_1: document.querySelector('.inner_1'),
        inner_2: document.querySelector('.inner_2'),
        inner_3: document.querySelector('.inner_3')
    }

    bgInit();

    turn = 0;
    indexPic = 1;
    picCounter = 3;
    firstTime = true;

    counters[1].textContent = pictures.length;

    picCounterBack = pictures.length - 1;

    console.log("Fore-", picCounter);
    console.log("Back-", picCounterBack);
}


// set the size of the inner divs (scroll left)

function sizeSet() {

    frames.inner_1.classList.remove('size-bg', 'size-fit');
    frames.inner_2.classList.remove('size-bg', 'size-fit');
    frames.inner_3.classList.remove('size-bg', 'size-fit');

    if (turn === 0) {
        frames.inner_1.classList.add('size-fit');
        frames.inner_2.classList.add('size-bg');
        frames.inner_3.classList.add('size-fit');
    } else if (turn === 1) {
        frames.inner_1.classList.add('size-fit');
        frames.inner_2.classList.add('size-fit');
        frames.inner_3.classList.add('size-bg');
    } else if (turn === 2) {
        frames.inner_1.classList.add('size-bg');
        frames.inner_2.classList.add('size-fit');
        frames.inner_3.classList.add('size-fit');
    }
};

//// set the size of the inner divs (scroll right)


function sizeSet_2() {
    frames.inner_1.classList.remove('size-bg', 'size-fit');
    frames.inner_2.classList.remove('size-bg', 'size-fit');
    frames.inner_3.classList.remove('size-bg', 'size-fit');

    if (turn === 0) {
        frames.inner_1.classList.add('size-fit');
        frames.inner_2.classList.add('size-fit');
        frames.inner_3.classList.add('size-bg');
    } else if (turn === 1) {
        frames.inner_1.classList.add('size-bg');
        frames.inner_2.classList.add('size-fit');
        frames.inner_3.classList.add('size-fit');
    } else if (turn === 2) {
        frames.inner_1.classList.add('size-fit');
        frames.inner_2.classList.add('size-bg');
        frames.inner_3.classList.add('size-fit');
    }
}

// set the position of the frames

function positionSet() {

    frames.frame_1.classList.remove('position-1', 'position-2', 'position-3');
    frames.frame_2.classList.remove('position-1', 'position-2', 'position-3');
    frames.frame_3.classList.remove('position-1', 'position-2', 'position-3');

    if (turn === 0) {
        frames.frame_1.classList.add('position-3');
        frames.frame_2.classList.add('position-1');
        frames.frame_3.classList.add('position-2');
    } else if (turn === 1) {
        frames.frame_1.classList.add('position-2');
        frames.frame_2.classList.add('position-3');
        frames.frame_3.classList.add('position-1');
    } else if (turn === 2) {
        frames.frame_1.classList.add('position-1');
        frames.frame_2.classList.add('position-2');
        frames.frame_3.classList.add('position-3');
    }

};

//// set the position of the frames (scroll right)

function positionSet_2() {

    frames.frame_1.classList.remove('position-1', 'position-2', 'position-3');
    frames.frame_2.classList.remove('position-1', 'position-2', 'position-3');
    frames.frame_3.classList.remove('position-1', 'position-2', 'position-3');

    if (turn === 0) {
        frames.frame_1.classList.add('position-2');
        frames.frame_2.classList.add('position-3');
        frames.frame_3.classList.add('position-1');
    } else if (turn === 1) {
        frames.frame_1.classList.add('position-1');
        frames.frame_2.classList.add('position-2');
        frames.frame_3.classList.add('position-3');
    } else if (turn === 2) {
        frames.frame_1.classList.add('position-3');
        frames.frame_2.classList.add('position-1');
        frames.frame_3.classList.add('position-2');
    }

};

// apply background to the frames for first time (animation-1)

function bgInit() {

    if (pictures.length === 1) {

        frames.inner_1.style.backgroundImage = `url("${pictures[0]}")`;
        frames.inner_2.style.backgroundImage = `url("${pictures[0]}")`;
        frames.inner_3.style.backgroundImage = `url("${pictures[0]}")`;

    } else if (pictures.length === 2) {

        frames.inner_1.style.backgroundImage = `url("${pictures[0]}")`;
        frames.inner_2.style.backgroundImage = `url("${pictures[1]}")`;
        frames.inner_3.style.backgroundImage = `url("${pictures[0]}")`;


    } else if (pictures.length > 2) {

        frames.inner_1.style.backgroundImage = `url("${pictures[0]}")`;
        frames.inner_2.style.backgroundImage = `url("${pictures[1]}")`;
        frames.inner_3.style.backgroundImage = `url("${pictures[2]}")`;

    }

};

// apply background to the frames for the first time (animation-2)

function bgInit_2() {

    if (pictures.length === 1) {

        frames.inner_1.style.backgroundImage = `url("${pictures[0]}")`;
        frames.inner_2.style.backgroundImage = `url("${pictures[0]}")`;
        frames.inner_3.style.backgroundImage = `url("${pictures[0]}")`;

    } else if (pictures.length === 2) {

        frames.inner_1.style.backgroundImage = `url("${pictures[0]}")`;
        frames.inner_2.style.backgroundImage = `url("${pictures[1]}")`;
        frames.inner_3.style.backgroundImage = `url("${pictures[1]}")`;

    } else if (pictures.length > 2) {

        frames.inner_1.style.backgroundImage = `url("${pictures[0]}")`;
        frames.inner_2.style.backgroundImage = `url("${pictures[1]}")`;
        frames.inner_3.style.backgroundImage = `url("${pictures[pictures.length - 1]}")`;

    }

};

// Change background pictures for animation-1

function changeBg() {

    if (picCounter < pictures.length && pictures.length > 3 && !firstTime) {

        if (frames.frame_1.classList.contains('position-3')) {

            frames.inner_1.style.backgroundImage = `url("${pictures[picCounter]}")`;

        } else if (frames.frame_2.classList.contains('position-3')) {

            frames.inner_2.style.backgroundImage = `url("${pictures[picCounter]}")`;

        } else if (frames.frame_3.classList.contains('position-3')) {

            frames.inner_3.style.backgroundImage = `url("${pictures[picCounter]}")`;

        }

    }
};

// Change background pictures for animation-1

function changeBg_2() {

    if (pictures.length > 3 && !firstTime) {

        if (frames.frame_1.classList.contains('position-3')) {

            frames.inner_1.style.backgroundImage = `url("${pictures[picCounterBack]}")`;

        } else if (frames.frame_2.classList.contains('position-3')) {

            frames.inner_2.style.backgroundImage = `url("${pictures[picCounterBack]}")`;

        } else if (frames.frame_3.classList.contains('position-3')) {

            frames.inner_3.style.backgroundImage = `url("${pictures[picCounterBack]}")`;

        }
    }
};

// initialize animation (start animation)

function initAnimation() {

    if (turn === 0) {
        frames.frame_1.style.animationName = animList.anim_1;
        frames.frame_2.style.animationName = animList.anim_2;
        frames.frame_3.style.animationName = animList.anim_3;
        frames.inner_2.style.animationName = animList.anim_4;
        frames.inner_1.style.animationName = animList.anim_5;
    } else if (turn === 1) {
        frames.frame_1.style.animationName = animList.anim_3;
        frames.frame_2.style.animationName = animList.anim_1;
        frames.frame_3.style.animationName = animList.anim_2;
        frames.inner_3.style.animationName = animList.anim_4;
        frames.inner_2.style.animationName = animList.anim_5;
    } else if (turn === 2) {
        frames.frame_1.style.animationName = animList.anim_2;
        frames.frame_2.style.animationName = animList.anim_3;
        frames.frame_3.style.animationName = animList.anim_1;
        frames.inner_1.style.animationName = animList.anim_4;
        frames.inner_3.style.animationName = animList.anim_5;
    }
};

// Initialize animation-2 

function initAnimation_2() {

    if (turn === 0) {
        frames.frame_1.style.animationName = animList.anim_7;
        frames.frame_2.style.animationName = animList.anim_8;
        frames.frame_3.style.animationName = animList.anim_6;
        frames.inner_3.style.animationName = animList.anim_5;
        frames.inner_1.style.animationName = animList.anim_9;

    } else if (turn === 1) {
        frames.frame_1.style.animationName = animList.anim_6;
        frames.frame_2.style.animationName = animList.anim_7;
        frames.frame_3.style.animationName = animList.anim_8;
        frames.inner_1.style.animationName = animList.anim_5;
        frames.inner_2.style.animationName = animList.anim_9;

    } else if (turn === 2) {
        frames.frame_1.style.animationName = animList.anim_8;
        frames.frame_2.style.animationName = animList.anim_6;
        frames.frame_3.style.animationName = animList.anim_7;
        frames.inner_2.style.animationName = animList.anim_5;
        frames.inner_3.style.animationName = animList.anim_9;
    }
};

// Clear animation-name property from all the divs 

function stopAnimation() {

    frames.frame_1.style.removeProperty('animation-name');
    frames.frame_2.style.removeProperty('animation-name');
    frames.frame_3.style.removeProperty('animation-name');
    frames.inner_1.style.removeProperty('animation-name');
    frames.inner_2.style.removeProperty('animation-name');
    frames.inner_3.style.removeProperty('animation-name');
};


function toRight() {

    stopAnimation();
    changeBg();
    initAnimation();
    sizeSet();
    positionSet();

    if (turn === 0) {
        //First position (frame_1 is big and frame_3 is hidden)
        turn = 1;
    } else if (turn === 1) {
        //Second position(frame_2 is big and frame_1 is hidden)
        turn = 2;
    } else if (turn === 2) {
        // Third position(frma_3 is big and frame_2 is hidden)
        turn = 0;
    }

    if (picCounter < (pictures.length - 1) && !firstTime) {
        picCounter++;
    } else if (!firstTime) {
        picCounter = 0;
    }

    if (picCounterBack < (pictures.length - 1)) {
        picCounterBack++;
    } else {
        picCounterBack = 0;
    }

    if (indexPic !== pictures.length) {
        indexPic++;
    } else {
        indexPic = 1;
    }
    counters[0].textContent = indexPic;

    firstTime = false;
    console.log("Fore-", picCounter);
    console.log("Back-", picCounterBack);

}



function toLeft() {

    if (firstTime) {
        bgInit_2()
    }

    if (indexPic !== 1) {
        indexPic--;
    } else {
        indexPic = pictures.length;
    }
    counters[0].textContent = indexPic;


    stopAnimation();
    changeBg_2();
    initAnimation_2();
    sizeSet_2();
    positionSet_2();

    if (turn === 0) {

        // First position (frame_1 is big and frame 3 is hidden)
        turn = 2;
    } else if (turn === 1) {

        //Second position(frame_2 is big and frame_1 is hidden)
        turn = 0;

    } else if (turn === 2) {

        // Third position(frma_3 is big and frame_2 is hidden)
        turn = 1;

    }

    if (picCounterBack > 0) {
        picCounterBack--;
    } else {
        picCounterBack = pictures.length - 1;
    }



    if (picCounter > 0) {
        picCounter--;
    } else {
        picCounter = pictures.length - 1;
    }

    if (firstTime) {
        picCounter = 1;
    }
    firstTime = false;

    console.log("Fore-", picCounter);
    console.log("Back-", picCounterBack);
}

function initEvents() {
    //Add hotkeys
    document.body.addEventListener("keydown", function (e) {
        if (e.key == "ArrowLeft")
            toLeft();
        else if (e.key == "ArrowRight")
            toRight();
    })

    document.querySelector('.slide-right').addEventListener('click', toRight);
    document.querySelector('.slide-left').addEventListener('click', toLeft);
}

export { initialize, toRight, toLeft, initEvents };